module.exports = __webpack_public_path__ + "img/Hotel-El-Dorado.e27f34d6.jpg";